module.exports = {
  mainHead: {
    platList_weibo: "Micro Blog",
    platList_douyin: "Tik Tok",
    platList_xhs: "Red Booklet",
    platList_bzhan: "bilibili",
    platList_kuaishou: "quick worker",
    platList_weixin: "WeChat",
    platList_jrtt: "toutiao",
    platList_zhihu: "zhihu",
    platList_dewu: "Poizon",
    platList_hupu: "hoopCHINA",
    cshop: "CSHOP",
    "cshop,tmall": "CSHOP and TMALL",
    "cshop,tmall,jd": "CSHOP and TMALL and JD",
    "cshop,tmall,douyin": "CSHOP and TMALL and Tik Tok",
    "cshop,jd": "CSHOP and JD",
    "tmall,jd": "TMALL and JD",
    global: "GLOBAL",
    tmall: "TMALL",
    tmallhk: "TMALLHK",
    chaoshi: "TMALL (supermarket)",
    tmallhk_gfzy: "TMALLHK(Official direct sale)",
    nochaoshi: "TMALL (non-supermarket)",
    notmallhk: "Non-Tmall Global",
    tmqjd: "TMALL(flagship store)",
    tmzyzmd: "TMALL(franchise/exclusive store)",
    jd: "JD",
    jd_only_self: "JD(self)",
    jd_exclude_self: "JD(3rd party)",
    jd_hk: "JD_GLOBAL",
    jd_home_self: "JD(home self)",
    jd_home_pop: "JD(home pop)",
    jd_not_home_self: "JD(not home self)",
    jd_not_home_pop: "JD(not home pop)",
    amazon: "Amazon",
    amazon_us: "Amazon US",
    amazon_de: "Amazon DE",
    amazon_es: "Amazon ES",
    amazon_fr: "Amazon FR",
    amazon_it: "Amazon IT",
    amazon_uk: "Amazon UK",
    amazon_jp: "Amazon JP",
    amazon_ae: "Amazon AE",
    amazon_sa: "Amazon SA",
    amazon_br: "Amazon Brazil",
    amazon_mx: "Amazon Mexico",
    shopee: "Shopee",
    shopee_vn: "Shopee VN",
    shopee_th: "Shopee TH",
    shopee_sg: "Shopee SG",
    shopee_my: "Shopee MY",
    shopee_ph: "Shopee PH",
    shopee_id: "Shopee ID",
    shopee_tw: "Shopee TW, China",
    lazada: "Lazada",
    lazada_vn: "Lazada VN",
    lazada_th: "Lazada TH",
    lazada_sg: "Lazada SG",
    lazada_my: "Lazada MY",
    lazada_ph: "Lazada PH",
    lazada_id: "Lazada ID",
  }
}
